// errorMapper.ts
export const ERROR_CODE_MAP: Record<string, string> = {
  ACCOUNT_AWAITS_TENANT_OWNERSHIP: "errors.accountAwaitsTenantOwnership",
  ACCOUNT_BEHIND_OPEN_INVITATION: "errors.accountBehindOpenInvitation",
  ACCOUNT_DEACTIVATED: "errors.accountDeactivated",
  ACCOUNT_DELETION_PENDING: "errors.accountDeletionPending",
  ACCOUNT_OWNS_DEVICES: "errors.accountOwnsDevices",
  ADMIN_CANNOT_DELETE_OWN_ACCOUNT: "errors.adminCannotDeleteOwnAccount",
  ALREADY_VIEWER: "errors.alreadyViewer",
  AUTHENTICATION_COOKIE_REQUIRED: "errors.authenticationCookieRequired",
  AUTHENTICATION_REQUIRED: "errors.authenticationRequired",
  AUTHENTICATION_REQUIRED_FOR_TOPICS: "errors.authenticationRequiredForTopics",

  CANNOT_DELETE_TENANT_OWNER: "errors.cannotDeleteTenantOwner",
  CANNOT_REMOVE_TENANT_OWNER: "errors.cannotRemoveTenantOwner",

  DEVICE_ACCESS_DENIED: "errors.deviceAccessDenied",
  DEVICE_ID_REQUIRED: "errors.deviceIdRequired",
  DEVICE_ID_REQUIRED_IN_URI: "errors.deviceIdRequiredInUri",
  DEVICE_INVALID_IP_ADDRESS: "errors.deviceInvalidIpAddress",
  DEVICE_IP_NOT_IN_ALLOWED_RANGE: "errors.deviceIpNotInAllowedRange",
  DEVICE_NOT_FOUND: "errors.deviceNotFound",
  DEVICE_NOT_IN_TENANT: "errors.deviceNotInTenant",
  DEVICE_NO_IP_ADDRESS: "errors.deviceNoIpAddress",
  DEVICE_UNAVAILABLE: "errors.deviceUnavailable",
  DEVICE_UNREACHABLE: "errors.deviceUnreachable",

  EMAIL_NOT_VERIFIED: "errors.emailNotVerified",
  EMAIL_ALREADY_EXISTS : "errors.emailAlreadyExists",

  FB_SIGNED_REQUEST_EMPTY: "errors.fbSignedRequestEmpty",
  FB_SIGNED_REQUEST_INVALID_BASE64: "errors.fbSignedRequestInvalidBase64",
  FB_SIGNED_REQUEST_INVALID_PAYLOAD: "errors.fbSignedRequestInvalidPayload",
  FB_SIGNED_REQUEST_MALFORMED: "errors.fbSignedRequestMalformed",
  FB_SIGNED_REQUEST_SIGNATURE_MISMATCH: "errors.fbSignedRequestSignatureMismatch",

  FCM_ACCESS_TOKEN_MISSING: "errors.fcmAccessTokenMissing",
  FCM_AUTH_FAILED: "errors.fcmAuthFailed",
  FCM_INVALID_PRIVATE_KEY: "errors.fcmInvalidPrivateKey",
  FCM_JWT_SIGNING_FAILED: "errors.fcmJwtSigningFailed",

  HANDLED_STAMP_NOT_FOUND: "errors.handledStampNotFound",

  HEADER_INVALID_TYPE: "errors.headerInvalidType",
  HEADER_NOT_ALLOWED: "errors.headerNotAllowed",
  HEADER_VALUE_TOO_LONG: "errors.headerValueTooLong",

  HTTP_METHOD_NOT_ALLOWED: "errors.httpMethodNotAllowed",

  IDP_UNEXPECTED_ERROR: "errors.idpUnexpectedError",
  INTERNAL_ERROR: "errors.internalError",

  INSUFFICIENT_ROLE: "errors.insufficientRole",

  INVALID_CREDENTIALS: "errors.invalidCredentials",
  INVALID_LOG_LEVEL: "errors.invalidLogLevel",
  INVALID_USER_CLASS: "errors.invalidUserClass",
  INVITATION_CONFLICT: "errors.invitationConflict",
  INVITATION_NOT_FOUND: "invitations.errors.not_found",
  INVITATION_NOT_RESENDABLE: "invitations.errors.not_resendable",
  INVITATION_RESENT_TOO_SOON: "invitations.errors.resent_too_soon",
  INVITEE_IS_TENANT_MEMBER: "errors.inviteeIsTenantMember",
  FUTURE_TENANT_OWNER_IS_ORG_ADMIN: "errors.futureTenantOwnerIsOrgAdmin",
  FUTURE_TENANT_OWNER_IS_ONLY_INVITED: "errors.futureTenantOwnerIsOnlyInvited",

  MEMBER_NOT_FOUND: "errors.memberNotFound",
  MESSAGE_HANDLER_NO_RESULT: "errors.messageHandlerNoResult",

  NETBIRD_API_ERROR: "errors.netbirdApiError",
  NETBIRD_CLIENT_REQUEST_FAILED: "errors.netbirdClientRequestFailed",
  NETBIRD_EMBEDDED_GROUP_NOT_FOUND: "errors.netbirdEmbeddedGroupNotFound",
  NETBIRD_REQUEST_FAILED: "errors.netbirdRequestFailed",

  OIDC_USER_CREATION_FAILED: "errors.oidcUserCreationFailed",

  PATH_EMPTY: "errors.pathEmpty",
  PATH_INVALID_START: "errors.pathInvalidStart",
  PATH_TOO_LONG: "errors.pathTooLong",
  PATH_TRAVERSAL_NOT_ALLOWED: "errors.pathTraversalNotAllowed",

  PAYLOAD_TOO_LARGE: "errors.payloadTooLarge",
  RATE_LIMIT_EXCEEDED: "errors.rateLimitExceeded",

  REQUEST_NOT_FOUND_IN_CONTEXT: "errors.requestNotFoundInContext",
  REQUEST_REQUIRED: "errors.requestRequired",

  SESSION_NOT_FOUND: "errors.sessionNotFound",

  SHARED_DEVICE_REMOVE_TENANT_ACCESS_INSTEAD: "errors.sharedDeviceRemoveTenantAccessInstead",

  SSO_EMAIL_EXISTS: "errors.ssoEmailExists",
  SSO_MISSING_ID_OR_TOKEN: "errors.ssoMissingIdOrToken",
  SSO_MULTIPLE_USERS_FOUND: "errors.ssoMultipleUsersFound",
  SSO_USER_ID_NOT_FOUND: "errors.ssoUserIdNotFound",

  STORAGE_ENCODING_FAILED: "errors.storageEncodingFailed",
  STORAGE_RECORD_CORRUPTED: "errors.storageRecordCorrupted",

  TECHNICIAN_NAME_REQUIRES_TENANT_MEMBERSHIP: "errors.technicianNameRequiresTenantMembership",
  TENANT_AWAITING_OWNER: "errors.tenantAwaitingOwner",
  TENANT_DEVICE_ACCESS_NOT_REMOVABLE: "errors.tenantDeviceAccessNotRemovable",
  TENANT_NAME_ALREADY_TAKEN: "errors.tenantNameAlreadyTaken",
  TENANT_NAME_REQUIRED: "errors.tenantNameRequired",
  TENANT_NAME_TOO_LONG: "errors.tenantNameTooLong",

  UNAUTHORIZED: "errors.unauthorized",
  UNAUTHORIZED_ROLE_ASSIGNMENT: "errors.unauthorizedRoleAssignment",

  USER_DELETE_FORBIDDEN: "errors.userDeleteForbidden",
  USER_ALREADY_BELONGS_TO_TENANT: "errors.userAlreadyBelongsToTenant",
  USER_ID_PARAMETER_REQUIRED: "errors.userIdParameterRequired",
  USER_ID_REQUIRED: "errors.userIdRequired",
  USER_INACTIVE: "errors.userInactive",
  USER_NOT_FOUND: "errors.userNotFound",

  ZITADEL_CLIENT_REQUEST_FAILED: "errors.zitadelClientRequestFailed",
  ZITADEL_REQUEST_FAILED: "errors.zitadelRequestFailed",
  ZITADEL_USER_NOT_ACTIVE: "errors.zitadelUserNotActive",

  INVALID_PASSWORD: "errors.invalid_password"
};
